const packDataToFormData = (data) => {
  let formData = new FormData();

  if (!data) return formData;
  for (let propertyName in data) {
    let propertyValue = data[propertyName];
    if (typeof propertyValue === "number" || typeof propertyValue === "string") 
      formData.append(propertyName, propertyValue);
    else if (Array.isArray(propertyValue)) {
      propertyValue.forEach(value => {
        formData.append(propertyName + "[]", value);
      });
    }
    else if (typeof propertyValue === "object") {
      formData.append(propertyName, JSON.stringify(propertyValue));
    }
  }

  return formData;
};

const dataArrayToFormData = (dataArray) => {
  let formData = new FormData();

  dataArray.forEach(field => {
    formData.append(field[0], field[1]);
  });

  return formData;
};


window.FormData.pack = packDataToFormData;
window.FormData.fromDataArray = dataArrayToFormData;

window.FormData.prototype.toDataArray = function() {
  return Array.from(this);
};

window.FormData.prototype.toDataObject = function() {
  let dataArray = this.toDataArray();
  let data = {};
  dataArray.forEach(field => data[field[0]] = field[1]);
  return data;
}

window.FormData.prototype.filter = function(cb) {
  let dataArray = this.toDataArray().filter(field => cb(field[0], field[1]));
  return FormData.fromDataArray(dataArray);
};